import {Component, Input} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {SimplePaginationComponent} from '../simple-pagination/simple-pagination.component';

@Component({
  selector: 'ds-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: PaginationComponent,
      multi: true
    }
  ],
})
export class PaginationComponent extends SimplePaginationComponent {

  @Input() firstTitle = 'First';
  @Input() lastTitle = 'Last';
  @Input() pageTitle = 'Page';

  constructor() {
    super();
  }

  selectLast(): void {
    this.value = this.lastPageIndex;
  }

  selectFirst(): void {
    this.value = 0;
  }
}

